module.exports = __webpack_public_path__ + "img/9.05410cc9.jpg";